/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Input,
  Spin,
  Card,
  Typography,
  DatePicker,
  InputNumber,
} from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, RedoOutlined } from '@ant-design/icons';
import { formatReceivedValues } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import {
  PARAMETRO_AREA,
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
} from 'utils/constants';
import { getModelPermission } from 'utils/permission';
import Select from 'components/Select';
import {
  getEstadosGlobales, getTiposDeNomina,
} from 'api/catalogos/index';
import {
  getConfiguracionSolicitudes,
  postConfiguracionSolicitud,
  deleteConfiguracionSolicitud,
  patchConfiguracionSolicitud,
  getConfiguracionSolicitud,
  autorizarConfiguracionSolicitud,
} from 'api/nominas/solicitudes/configuracionDeSolicitudes';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';
import { getPeriodicidadDePercepciones } from 'api/nominas/percepciones/periodicidadDePercepciones';
import { getParametrosDeSolicitudes } from 'api/nominas/solicitudes/solicitudesParametros';
import { getPercepcionesTiposDeNominas } from 'api/nominas/percepciones/percepcionesTiposDeNomina';
import { getPercepcionesTiposDeNominasEmpleados } from 'api/nominas/percepciones/percepcionesTiposDeNominaEmpleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
} from 'utils/patterns';
import CurrencyInput from 'components/CurrencyInput';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import SolcitudesAreas, { solicitudAreaPermission } from './SolicitudesAreas';
import SolicitudesPlazas from './SolicitudesPlazas';
import SolicitudesPeriodosValidacion from './SolicitudesPeriodosValidacion';
import SolicitudesIncidenciasReloj from './SolicitudesIncidenciasReloj';

export const configuracionSolicitudPermission = {
  permissionModel: 'solicitud',
  catalogsModels: [],
  tabsModels: [],
};

const ESTATUS_SELECCIONABLES = [ESTATUS_ACTIVO, ESTATUS_INACTIVO];

const { Text } = Typography;

const ConfiguracionSolicitudes = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [percepciones, setPercepciones] = useState([]);
  const [periodicidades, setPeriodicidades] = useState([]);
  const [parametros, setParametros] = useState([]);
  const [periodicidad, setPeriodicidad] = useState();
  const [esImporteFijo, setEsImporteFijo] = useState();
  const [importeFijo, setImporteFijo] = useState();
  const [parametro, setParametro] = useState();
  const [percepcionesTipoDeNomina, setPercepcionesTipoDeNomina] = useState([]);
  const [percepcionesTipoDeNominaEmpleado, setPercepcionesTipoDeNominaEmpleado] = useState([]);
  const [tipoDeNomina, setTipoDeNomina] = useState([]);
  const [tipoDeNominaEmpleado, setTipoDeNominaEmpleado] = useState([]);
  const [disableParametroPercepcion, setDisableParametroPercepcion] = useState(false);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);
  const [disableEdit, setDisableEdit] = useState(false);
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [tiposEmpleadosCatalog, setTiposEmpleadosCatalog] = useState([]);
  const [aplicaPorPlaza, setAplicaPorPlaza] = useState(false);
  const [aplicaIncidenciasReloj, setAplicaIncidenciasReloj] = useState(false);
  const [tiposDeContratacion, setTiposDeContratacion] = useState([]);

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        percepcion_periodicidad: e?.percepcion,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const formInstances = [
    form,
  ];

  const getPermission = getModelPermission(
    solicitudAreaPermission.permissionModel,
    solicitudAreaPermission.catalogsModels,
    solicitudAreaPermission.tabsModels,
    false,
  );

  const fetchData = async () => {
    setLoading(true);
    const _data = await getConfiguracionSolicitudes();
    setData(formatReceivedClone(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _percepciones,
        _periodicidades,
        _parametros,
        _tipoDeNomina,
        _tipoDeNominaEmpleado,
        _tiposEmpleadosCatalog,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPercepciones({ estados_globales: ESTATUS_AUTORIZADO, es_solicitable: true }),
        getPeriodicidadDePercepciones({ estados_globales: ESTATUS_AUTORIZADO }),
        getParametrosDeSolicitudes(),
        getTiposDeNomina(),
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getTiposDeEmpleados(),
        getConfiguracionSolicitudes(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setEstadosFiltered(_estados.filter((e) => ESTATUS_SELECCIONABLES.includes(e?.id)));
        setPercepciones(_percepciones);
        setPeriodicidades(_periodicidades);
        setParametros(_parametros);
        setTipoDeNomina(_tipoDeNomina);
        setTiposEmpleadosCatalog(_tiposEmpleadosCatalog);
        setTipoDeNominaEmpleado(_tipoDeNominaEmpleado);
        setData(formatReceivedClone(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setPeriodicidad();
    setEsImporteFijo();
    setImporteFijo();
    setParametro();
    setPercepcionesTipoDeNomina([]);
    setPercepcionesTipoDeNominaEmpleado([]);
    setDisableParametroPercepcion(false);
    setDisableEdit(false);
    setEstadosFiltered(estados.filter((e) => ESTATUS_SELECCIONABLES.includes(e?.id)));
    setVisibleConfirmInactivo(false);
    setAplicaPorPlaza(false);
    form.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _solicitud = await getConfiguracionSolicitud(match.id);
    setTimeout(() => {
      if (_solicitud) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceivedClone(_solicitud));
          setParametro(_solicitud.solicitud_tipo_de_parametro);
          setPeriodicidad(percepciones.find((e) => e.id === _solicitud.percepcion)?.periodicidad_de_percepcion);
          setEsImporteFijo(percepciones.find((e) => e.id === _solicitud.percepcion)?.es_percepcion_importe_fijo);
          const _percepcion_obj = percepciones.find((e) => e.id === _solicitud.percepcion);
          if (percepciones.find((e) => e.id === _solicitud.percepcion)?.es_percepcion_importe_fijo) {
            setImporteFijo(() => _percepcion_obj?.importe_fijo_por_evento || _percepcion_obj?.importe_diario || _percepcion_obj?.importe_mensual);
          } else {
            setImporteFijo();
          }
          getPercepcionesTiposDeNominas({ percepcion: form.getFieldValue('percepcion') })
            .then((_data) => {
              setPercepcionesTipoDeNomina(_data);
            });
          getPercepcionesTiposDeNominasEmpleados({ percepcion: form.getFieldValue('percepcion') })
            .then((_data) => {
              setPercepcionesTipoDeNominaEmpleado(_data);
            });
          const _percepcionSolicitudImporte = percepciones.find((e) => e.id === match.percepcion)?.aplica_importe_pagado_por_solicitud;
          const _aplicaSolicitudImporte = form.getFieldValue('solicitud_tipo_de_parametro');
          if (_aplicaSolicitudImporte === 4 && _percepcionSolicitudImporte) {
            setDisableParametroPercepcion(true);
          } else {
            setDisableParametroPercepcion(false);
          }
          if (_solicitud?.estados_globales === ESTATUS_AUTORIZADO) {
            setEstadosFiltered(estados.filter((e) => e?.id === ESTATUS_AUTORIZADO));
          }
          setDisableEdit(_solicitud?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);

          setAplicaPorPlaza(_solicitud.aplica_importe_por_plaza);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchConfiguracionSolicitud(key, values) : postConfiguracionSolicitud(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteConfiguracionSolicitud(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onChangePercepcion = (value) => {
    setPeriodicidad(percepciones.find((e) => e.id === value)?.periodicidad_de_percepcion);
    setEsImporteFijo(percepciones.find((e) => e.id === value)?.es_percepcion_importe_fijo);
    const _percepcion_obj = percepciones.find((e) => e.id === value);
    if (percepciones.find((e) => e.id === value)?.es_percepcion_importe_fijo) {
      setImporteFijo(() => _percepcion_obj?.importe_fijo_por_evento || _percepcion_obj?.importe_diario || _percepcion_obj?.importe_mensual);
    } else {
      setImporteFijo();
    }
    const _aplicaSolicitudImporte = percepciones.find((e) => e.id === value)?.aplica_importe_pagado_por_solicitud;
    if (_aplicaSolicitudImporte) {
      form.setFieldValue('solicitud_tipo_de_parametro', 4);
      setDisableParametroPercepcion(true);
    } else {
      setDisableParametroPercepcion(false);
    }

    if (value) {
      getPercepcionesTiposDeNominas({ percepcion: value })
        .then((_data) => {
          setPercepcionesTipoDeNomina(_data);
        });

      getPercepcionesTiposDeNominasEmpleados({ percepcion: value })
        .then((_data) => {
          setPercepcionesTipoDeNominaEmpleado(_data);
        });
    } else {
      setPercepcionesTipoDeNomina([]);
      setPercepcionesTipoDeNominaEmpleado([]);
    }
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una solicitud de percepción ya autorizada');
        return;
      }
      const saved = await autorizarConfiguracionSolicitud(key);
      if (saved) {
        const _data = await getConfiguracionSolicitudes();
        setData(formatReceivedClone(_data));
        setVisibleAutorizar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        setVisibleCancelar(false);
        return;
      }
      const saved = await patchConfiguracionSolicitud(key, { estados_globales: ESTATUS_CANCELADO });
      if (saved) {
        const _data = await getConfiguracionSolicitudes();
        setData(formatReceivedClone(_data));
        setVisibleCancelar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        setVisibleReactivar(false);
        return;
      }
      const saved = await patchConfiguracionSolicitud(key, { estados_globales: ESTATUS_ACTIVO });
      if (saved) {
        const _data = await getConfiguracionSolicitudes();
        setData(formatReceivedClone(_data));
        setVisibleReactivar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Percepción',
      dataIndex: 'percepcion',
      key: 'percepcion',
      width: 200,
      render: (val) => {
        const _percepciones = percepciones.find((e) => e.id === val);
        return `${_percepciones?.clave} - ${_percepciones?.descripcion}`;
      },
    },
    {
      titleText: 'Requiere Petición',
      dataIndex: 'requiere_peticion',
      key: 'requiere_peticion',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Periodicidad',
      dataIndex: 'percepcion_periodicidad',
      key: 'percepcion_periodicidad',
      width: 200,
      render: (val) => {
        const _percepcion = percepciones.find((e) => e.id === val);
        return periodicidades.find((e) => e.id === _percepcion?.periodicidad_de_percepcion)?.descripcion;
      },
    },
    {
      titleText: 'Parámetro',
      dataIndex: 'solicitud_tipo_de_parametro',
      key: 'solicitud_tipo_de_parametro',
      width: 200,
      render: (val) => parametros.find((e) => e.id === val)?.nombre,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const columnsTipoNomina = [
    {
      titleText: 'Tipo de Nómina',
      dataIndex: 'tipo_de_nomina',
      key: 'tipo_de_nomina',
      width: 300,
      render: (val) => tipoDeNomina?.find((e) => e.id === val)?.descripcion,
    },
  ];

  const columnsTipoNominaEmpleado = [
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 300,
      render: (val) => tipoDeNominaEmpleado?.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'solicitud', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                className: 'success',
                disabledBySelection: false,
                disabled: data?.find((e) => e.id === selectedRowKeys[0])?.estados_globales !== ESTATUS_ACTIVO,
              },
              {
                onClick: () => setVisibleCancelar(true),
                permission: { model: 'solicitud', action: 'cancelar' },
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                className: 'cancel',
                disabledBySelection: false,
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO,
              },
              {
                onClick: () => setVisibleReactivar(true),
                permission: { model: 'solicitud', action: 'reactivar' },
                text: 'Reactivar',
                icon: <RedoOutlined />,
                className: 'success',
                disabledBySelection: false,
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e.id === selectedRowKeys[0])?.estados_globales === ESTATUS_ACTIVO,
              },
            ]}
            disableDelete={data?.find((e) => e.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO}
            permission={permission}
            allowExportPDF={false}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Solicitud de Percepción`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                allowSave={!disableEdit}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
              initialValues={{
                tiene_limite_maximo_sueldo: false,
                aplica_tipo_nominas_empleados: false,
                aplica_antiguedad_minima: false,
                aplica_tipo_contratacion: false,
                aplica_importe_por_plaza: false,
                aplica_incidencias_reloj_checador: false,
                estados_globales: 1,
              }}
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clave"
                    label="Clave"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="percepcion"
                    label="Percepción"
                    rules={rules.estatus}
                    hasFeedback
                  >
                    <Select
                      dataSource={percepciones}
                      onChange={onChangePercepcion}
                      render={(val) => `${val?.clave} - ${val?.descripcion}`}
                      disabled={disableEdit}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Periodicidad"
                    hasFeedback
                  >
                    <Select
                      dataSource={periodicidades}
                      value={periodicidad}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Tiene Importe Fijo"
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      value={esImporteFijo}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    label="Importe Fijo"
                    value={importeFijo}
                    disabled
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="solicitud_tipo_de_parametro"
                    label="Parámetro de Asignación de Percepción"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      keyProp="id"
                      labelProp="nombre"
                      disabled={disableParametroPercepcion || disableEdit}
                      dataSource={parametros}
                      onChange={(value) => {
                        setParametro(value);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* <Col xs={24} sm={24} md={16}>
                  <Form.Item
                    name="requiere_peticion"
                    label="Requiere Petición del Empleado o Requisitos Previos"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      disabled={disableEdit}
                    />
                  </Form.Item>
                </Col> */}
              <Row gutter={24}>
                {/* --- LÍMITE MÁXIMO DE SUELDO --- */}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tiene_limite_maximo_sueldo"
                    label="Tiene Límite Máximo de Sueldo"
                    hasFeedback
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>

                <Form.Item
                  noStyle
                  shouldUpdate={(prev, curr) => prev.tiene_limite_maximo_sueldo !== curr.tiene_limite_maximo_sueldo}
                >
                  {({ getFieldValue }) => {
                    const habilitado = getFieldValue('tiene_limite_maximo_sueldo');
                    return habilitado ? (
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="importe_limite_maximo_sueldo"
                          label="Importe Límite Máximo"
                          hasFeedback
                          rules={[{ required: true, message: 'Requerido' }]}
                        >
                          <InputNumber
                            style={{ width: '100%' }}
                            formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                          />
                        </Form.Item>
                      </Col>
                    ) : null;
                  }}
                </Form.Item>

                {/* --- TIPO DE EMPLEADOS --- */}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_tipo_nominas_empleados"
                    label="Aplica Tipo de Empleados"
                    hasFeedback
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>

                <Form.Item
                  noStyle
                  shouldUpdate={(prev, curr) => prev.aplica_tipo_nominas_empleados !== curr.aplica_tipo_nominas_empleados}
                >
                  {({ getFieldValue }) => {
                    const habilitado = getFieldValue('aplica_tipo_nominas_empleados');
                    return habilitado ? (
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipos_nominas_empleados"
                          label="Tipo de Empleado"
                          hasFeedback
                          rules={[{ required: true, message: 'Seleccione al menos uno' }]}
                        >
                          <Select
                            mode="multiple"
                            keyProp="id"
                            labelProp="descripcion"
                            dataSource={tipoDeNominaEmpleado}
                            allowClear
                          />
                        </Form.Item>
                      </Col>
                    ) : null;
                  }}
                </Form.Item>

                {/* --- ANTIGÜEDAD MÍNIMA --- */}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_antiguedad_minima"
                    label="Aplica Antigüedad Mínima"
                    hasFeedback
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>

                <Form.Item
                  noStyle
                  shouldUpdate={(prev, curr) => prev.aplica_antiguedad_minima !== curr.aplica_antiguedad_minima}
                >
                  {({ getFieldValue }) => {
                    const habilitado = getFieldValue('aplica_antiguedad_minima');
                    return habilitado ? (
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="antiguedad_minima"
                          label="Antigüedad Mínima"
                          hasFeedback
                          rules={[{ required: true, message: 'Requerido' }]}
                        >
                          <InputNumber
                            style={{ width: '100%' }}
                            addonAfter="Días"
                            min={0}
                          />
                        </Form.Item>
                      </Col>
                    ) : null;
                  }}
                </Form.Item>

                {/* --- APLICA TIPO DE CONTRATACIÓN --- */}
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_tipo_contratacion"
                    label="Aplica Tipo de Contratación"
                    hasFeedback
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>

                <Form.Item
                  noStyle
                  shouldUpdate={(prev, curr) => prev.aplica_tipo_contratacion !== curr.aplica_tipo_contratacion}
                >
                  {({ getFieldValue }) => {
                    const habilitado = getFieldValue('aplica_tipo_contratacion');
                    return habilitado ? (
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_contratacion"
                          label="Tipo de Contratación"
                          hasFeedback
                          rules={[{ required: true, message: 'Requerido' }]}
                        >
                          <Select
                            keyProp="id"
                            labelProp="descripcion"
                            dataSource={tiposDeContratacion}
                            allowClear
                          />
                        </Form.Item>
                      </Col>
                    ) : null;
                  }}
                </Form.Item>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_importe_por_plaza"
                    label="Aplica Importe por Plaza"
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      onChange={(val) => setAplicaPorPlaza(val)}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_incidencias_reloj_checador"
                    label="Aplica Incidencias de Reloj Checador"
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      disabled={disableEdit}
                      onChange={(val) => setAplicaIncidenciasReloj(val)}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.estatus}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estadosFiltered}
                      disabled={selectedRowKeys.length <= 0 || disableEdit}
                      onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={100} style={{ marginBottom: '2.5rem' }}>
                <Col xs={24} sm={24} md={12}>
                  <Text style={{ color: '#D88F4F' }}>Tipo de Nómina</Text>
                  <Table
                    cols={columnsTipoNomina}
                    data={percepcionesTipoDeNomina}
                    pagination={false}
                    allowExportParam={false}
                    mobileColIndex={0}
                  />
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Text style={{ color: '#D88F4F' }}>Tipo de Nómina Empleado</Text>
                  <Table
                    cols={columnsTipoNominaEmpleado}
                    data={percepcionesTipoDeNominaEmpleado}
                    pagination={false}
                    allowExportParam={false}
                    mobileColIndex={0}
                  />
                </Col>
              </Row>
              {/* <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_sueldo_promedio_periodo"
                    label="Aplica Sueldo Promedio del Periodo"
                    hasFeedback
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_inicial_periodo_promedio"
                    label="Fecha Inicial del Periodo del Promedio"
                    hasFeedback
                  >
                    <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_final_periodo_promedio"
                    label="Fecha Final del Periodo del Promedio"
                    hasFeedback
                  >
                    <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="se_resta_anticipo"
                    label="Se Resta Anticipo"
                    hasFeedback
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={16}>
                  <Form.Item
                    name="percepcion_del_anticipo"
                    label="Percepción del Anticipo"
                    hasFeedback
                  >
                    <Select
                      dataSource={percepciones} // o el catálogo específico si lo tienes
                      keyProp="id"
                      render={(val) => `${val?.clave} - ${val?.descripcion}`}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_calculo_piramidado"
                    label="Aplica Cálculo Piramidado"
                    hasFeedback
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="aplica_calculo_directo"
                    label="Aplica Cálculo Directo"
                    hasFeedback
                  >
                    <Select trueFalse />
                  </Form.Item>
                </Col>
              </Row> */}
              {selectedRowKeys.length && parametro === PARAMETRO_AREA
                ? (
                  <SolcitudesAreas
                    permission={getPermission}
                    selected={selectedRowKeys[0]}
                  />
                ) : null}

              {selectedRowKeys.length && aplicaPorPlaza ? (
                <SolicitudesPlazas
                  permission={getPermission} // O crea uno específico si es necesario
                  selected={selectedRowKeys[0]}
                  estatusInactivo={data?.find((e) => e.id === selectedRowKeys[0])?.estados_globales !== ESTATUS_ACTIVO}
                />
              ) : null}

              {selectedRowKeys.length && aplicaIncidenciasReloj ? (
                <>
                  {/* Primer Grid: Incidencias */}
                  <SolicitudesIncidenciasReloj
                    permission={getPermission}
                    selected={selectedRowKeys[0]}
                    estatusInactivo={data?.find((e) => e.id === selectedRowKeys[0])?.estados_globales !== ESTATUS_ACTIVO}
                  />

                  {/* Segundo Grid: Periodos */}
                  <SolicitudesPeriodosValidacion
                    permission={getPermission}
                    selected={selectedRowKeys[0]}
                    estatusInactivo={data?.find((e) => e.id === selectedRowKeys[0])?.estados_globales !== ESTATUS_ACTIVO}
                  />
                </>
              ) : null}
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Solicitud de Percepción ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle={`Autorizar la Solicitud de Percepción ${form.getFieldValue('clave')}`}
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmCancelar}
          ConfirmCancel
          onCancel={() => setVisibleCancelar(false)}
          contentTitle={`Cancelar la Solicitud de Percepción ${form.getFieldValue('clave')}`}
          open={visibleCancelar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => setVisibleReactivar(false)}
          contentTitle={`Reactivar la Solicitud de Percepción ${form.getFieldValue('clave')}`}
          open={visibleReactivar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleConfirmInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleConfirmInactivo(false);
          }}
          contentTitle={`Inactivar la Solicitud de Percepción ${form.getFieldValue('clave')}`}
          open={visibleConfirmInactivo}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default ConfiguracionSolicitudes;
